module.exports = __webpack_public_path__ + "static/media/S4N10-3.a870dbdc.svg";